import { render } from "./SelectBox.vue?vue&type=template&id=3dc3aa4e"
import script from "./SelectBox.vue?vue&type=script&lang=js"
export * from "./SelectBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/components/Basic/Forms/SelectBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dc3aa4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dc3aa4e', __exports__)) {
    api.reload('3dc3aa4e', __exports__)
  }
  
  module.hot.accept("./SelectBox.vue?vue&type=template&id=3dc3aa4e", () => {
    api.rerender('3dc3aa4e', render)
  })

}


export default __exports__